/** @jsxRuntime classic */
/** @jsx jsx */
import { css } from '@emotion/react';
import { N_A } from '../../../lib/constants';
import { ThemeColors } from '../../../styles/theme';

export const containerCss = css`
	font-size: 14px;
	max-width: 800px;
	min-height: 100%;
	height: fit-content !important;
	overflow-y: auto;
	background: white;
	display: flex;
	flex-direction: column;
	padding: 20px;

	.flex {
		display: flex;
	}

	.questions-container {
		margin-top: 8px;
		margin-bottom: 8px;
	}

	.flex-col {
		flex-direction: column;
	}

	.mt-8 {
		margin-top: 8px;
	}

	.customer-details-container {
		border-radius: 0.8rem;
		border: 1px solid ${ThemeColors.bg_border_primary};
		background: ${ThemeColors.bg_background_primary};
		padding: 1rem;
		margin-top: 0.8rem;
	}
`;

export const answerCss = css`
	margin: 0 0 16px 0;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	word-break: break-word;

	.textData {
		width: 100%;
		margin-top: 4px;
		margin-bottom: 8px;
	}

	.answer {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		word-break: break-word;
	}

	.choiceList,
	.fileAnswer,
	.fileAnswerItem {
		display: flex;
		flex-direction: column;
	}

	.choiceItem,
	.fileName,
	.fileUrl {
		word-break: break-all;
		overflow-wrap: anywhere;
		hyphens: none;
	}

	.fileImage {
		display: block;
		max-height: 180px;
		max-width: 100%;
		width: auto;
		height: auto;
		object-fit: contain;
		object-position: left top;
		margin-bottom: 8px;
	}

	.consentAgreed {
		display: inline-flex;
		align-items: center;
		gap: 0.6rem;
	}

	.checkedBox {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 1.4rem;
		height: 1.4rem;
		border: 1px solid ${ThemeColors.tx_text_primary};
		border-radius: 0.2rem;
		flex-shrink: 0;
	}

	.checkedBox svg {
		width: 1rem;
		height: 1rem;
	}
`;

export const sectionCss = css`
	margin: 20px 0;
	.header {
		text-align: center;
		font-variant-numeric: tabular-nums;
	}
	.title {
		font-size: 1.6rem;
		line-height: 2rem;
		font-weight: 700;
		margin: 0 0 0.4rem;
	}
	.address {
		font-size: 1.1rem;
		line-height: 1.6rem;
		word-break: normal;
		overflow-wrap: break-word;
		margin-bottom: 0.4rem;
	}
	.email_phone {
		font-size: 1.1rem;
		line-height: 1.6rem;
	}
	.divider {
		margin: 0 5px;
	}
	h4 {
		font-size: 1.4rem;
		line-height: 1.8rem;
	}
`;
export const detailsCss = (data: string) => css`
	div {
		color: unset;
		font-weight: ${data === N_A ? 'bold' : 'unset'};
	}
`;
export const customerDetailLineCss = css`
	display: flex;
	margin-top: 8px;
	margin-bottom: 8px;
	gap: 16px;
`;
